import { api } from '@/services';

export default {
  async fetchContainers({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/processo/container', { params: params || [] });
    commit('SET_CONTAINERS', response.data);
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  async prepararExcel() {
    const { data } = await api.get('/processo/container/excel');

    return data;
  },
  async selecionarContainer({ commit }, container) {
    const { CODIGO_PROCESSO, CODIGO_FILIAL, NUMERO_CONTAINER } = container;
    const { data } = await api.get(
      `/processo/container/${CODIGO_PROCESSO}/${CODIGO_FILIAL}/${NUMERO_CONTAINER}`,
    );
    commit('SET_CONTAINER_SELECIONADO', container);
    commit('SET_DETALHES', data);
  },
  limparContainers({ commit }) {
    commit('SET_CONTAINERS', null);
    commit('SET_CONTAINER_SELECIONADO', null);
    commit('SET_DETALHES', []);
  },
};
